// The consent a person gives before approving a credential request. Its wording names who asked:
// the requesting company, or the requester when the request names no company. Share stays
// unavailable until it is ticked.

import React from 'react';
import { Checkbox } from 'antd';
import { renderApprovalWording } from '../../util/consentWordings';

const ApprovalShareConsent = ({ checked, onChange, disabled, requesterLabel }) => (
  <div style={{ marginTop: '16px' }}>
    <Checkbox checked={checked} disabled={disabled} onChange={e => onChange(e.target.checked)}>
      {renderApprovalWording(requesterLabel)}
    </Checkbox>
  </div>
);

export default ApprovalShareConsent;
